// extracted by mini-css-extract-plugin
export default {"error-page":"Live_error-page__ZSd0e","error-image":"Live_error-image__f6IRw"};